const getters = {
  processing: (state) => state.processing,
  settlements: (state) => state.settlements,
  showSettlements: (state) => state.showSettlements,
  importResult: (state) => state.importResult,
};
export default getters;
